import { KeyConstructor } from './keyConstructor';
const MEMBER_KEY = 'member';
const MEMBERS_KEY = 'members';
const SPACE_MEMBER_KEY = 'spaceMember';
const MEMBERS_BY_IDS_KEY = 'membersByIds';
const SPACE_MEMBERS_KEY = 'spaceMembers';
export const getMemberKey = KeyConstructor(MEMBER_KEY);
export const getMembersByIdsKey = KeyConstructor(MEMBERS_BY_IDS_KEY);
export const getMembersKey = KeyConstructor(MEMBERS_KEY);
export const getSpaceMemberKey = KeyConstructor(SPACE_MEMBER_KEY);
export const getSpaceMembersKey = KeyConstructor(SPACE_MEMBERS_KEY);
//# sourceMappingURL=member.key.js.map